import swal from 'sweetalert';

export const OPERATIONAL_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: '1', label: 'Pending' },
  { value: '3', label: 'Approved' },
  { value: '4', label: 'Day closed' },
];

export const DEFAULT_OPERATIONAL_LIST_FILTERS = {
  from_date: '',
  to_date: '',
  amount: '',
  search_keyword: '',
  status: '',
};

export const validateOperationalDateRange = (fromDate, toDate) => {
  if (!fromDate || !toDate) {
    return true;
  }
  if (toDate < fromDate) {
    swal('Invalid date range', 'To date should be greater than or equal to from date', 'warning');
    return false;
  }
  return true;
};

export const appendOperationalListFilters = (params, filters = {}) => {
  if (filters.from_date) params.set('from_date', filters.from_date);
  if (filters.to_date) params.set('to_date', filters.to_date);
  if (filters.amount) params.set('amount', filters.amount);
  if (filters.search_keyword) params.set('search_keyword', filters.search_keyword);
  if (filters.status) params.set('status', filters.status);
  return params;
};
